const date = new Date();

export const collectionInteractionFields = vueInstance => [
  {
    name: 'contactMethod',
    title: vueInstance.$t('contactMethod'),
    type: 'select',
    possibleOptions: [],
    useDictionary: true,
    defaultValue: null
  },
  {
    name: 'gotAnswerFromClient',
    title: vueInstance.$t('gotAnswerFromClient'),
    type: 'select',
    possibleOptions: [
      { name: vueInstance.$t('null'), slug: null },
      { name: vueInstance.$t('yes'), slug: true },
      { name: vueInstance.$t('no'), slug: false }
    ],
    defaultValue: null
  },
  {
    name: 'willPayAt',
    title: vueInstance.$t('willPayAt'),
    type: 'datepicker',
    defaultValue: null
  },
  {
    name: 'isAbleToPay',
    title: vueInstance.$t('isAbleToPay'),
    type: 'select',
    possibleOptions: [
      { name: vueInstance.$t('null'), slug: null },
      { name: vueInstance.$t('yes'), slug: true },
      { name: vueInstance.$t('no'), slug: false }
    ],
    defaultValue: null
  },
  {
    name: 'isImportant',
    title: vueInstance.$t('isImportant'),
    type: 'select',
    possibleOptions: [
      { name: vueInstance.$t('null'), slug: null },
      { name: vueInstance.$t('yes'), slug: true },
      { name: vueInstance.$t('no'), slug: false }
    ],
    defaultValue: false
  },
  {
    name: 'alreadyPaid',
    title: vueInstance.$t('alreadyPaid'),
    type: 'select',
    possibleOptions: [
      { name: vueInstance.$t('yes'), slug: true },
      { name: vueInstance.$t('no'), slug: false }
    ],
    defaultValue: false
  },
  {
    name: 'nextCollectionDate',
    title: vueInstance.$t('nextCollectionDate'),
    type: 'datepicker',
    defaultValue: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 15)
  },
  {
    name: 'address',
    title: 'Dirección',
    type: 'text',
    defaultValue: ''
  },
  {
    name: 'availabilityInitialHour',
    title: 'Horario inicial de disponibilidad',
    type: 'timePicker',
    defaultValue: null
  },
  {
    name: 'availabilityEndHour',
    title: 'Horario final de disponibilidad',
    type: 'timePicker',
    defaultValue: null
  }
];
